import type { ComponentSchema } from '../../../../../schema-types'

/** Torongo text section: page column, home article with "Read more", or FAQ cards. Keys follow lightings-1. */
export const schema: ComponentSchema = {
  type: 'content',
  label: 'Text / FAQ',
  description: 'Policies and other text pages, the home page’s “Read more” article, or questions as cards and an accordion.',
  supportedPages: ['home', 'shop', 'category', 'contact', 'privacy-policy', 'terms-of-service', 'shipping-policy', 'return-policy', 'track-order'],
  variants: [
    { id: 'v1', label: 'Text page (readable column)' },
    { id: 'v2', label: 'Article with “Read more”' },
    { id: 'v3', label: 'FAQ (two-column cards, then an accordion)' },
  ],
  commonFields: [
    { key: 'title', label: 'Title', type: 'string' },
    { key: 'subtitle', label: 'Subtitle / intro', type: 'localized-text', help: 'In the article layout this is the part shown before “Read more”.' },
    { key: 'content', label: 'Text', type: 'rich-text' },
    {
      key: 'faqs',
      label: 'Questions and answers',
      type: 'array',
      help: 'Shown as an accordion under the text (also published as FAQ structured data).',
      itemSchema: [
        { key: 'question', label: 'Question', type: 'string' },
        { key: 'answer', label: 'Answer', type: 'text' },
      ],
    },
    { key: 'updatedText', label: 'Last updated note', type: 'string', placeholder: 'Last updated 1 January 2026' },
  ],
}
